import SoundEngine from './SoundEngine';

export default class Progress extends SoundEngine {
  play () {
    const verb = this.fx.verb(1);

    const aOsc = this.osc.triangle();
    const aGain = this.fx.gain();
    const aFilter = this.fx.filter();

    const aLength = 0.5;
    aOsc.frequency.setValueAtTime(440, this.now);
    aOsc.frequency.setValueAtTime(659.25, this.now + (aLength / 5));
    aGain.gain.setValueAtTime(0.5, this.now);
    aGain.gain.linearRampToValueAtTime(0.0001, this.now + aLength);

    aOsc.connect(aGain);
    aGain.connect(aFilter);
    aFilter.connect(this.output);
    aFilter.connect(verb);

    const bOsc = this.osc.sawtooth();
    const bGain = this.fx.gain();
    const bFilter = this.fx.filter();

    const bLength = 0.1;
    bFilter.frequency.setValueAtTime(1000, this.now);
    bOsc.frequency.setValueAtTime(440, this.now);
    bGain.gain.setValueAtTime(0.15, this.now);
    bGain.gain.linearRampToValueAtTime(0.0001, this.now + bLength);

    bOsc.connect(bGain);
    bGain.connect(bFilter);
    bFilter.connect(this.output);
    bFilter.connect(verb);

    const verbGain = this.fx.gain();
    verbGain.gain.setValueAtTime(0.2, this.now);
    verb.connect(verbGain);
    verbGain.connect(this.output);

    aOsc.start();
    aOsc.stop(this.now + aLength);
    bOsc.start();
    bOsc.stop(this.now + bLength);
  }
}
